import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { selectEventCategoryPreService } from '@features/eventDetail/slices/eventDetailClientSlice';
import servicesInputFactory from '@features/subscriptions/factories/servicesInputFactory';
import { TextAlignment } from '@features/ui-input/formik/MultiInputLine';
import ServiceLineRaw from '@features/subscriptions/components/ServiceLine/ServiceLineRaw';
import { InputLineProps } from '@features/ui-input/formik/InputLine';
import { selectEventCurrency } from '@features/eventDetail/slices/eventDetailServerSlice';
import { selectCurrentCartDetail } from '@features/carts/slices/cartsSlice';

interface PreServiceLineEventSubscriptionProps {
  serviceId: number;
  eventId: number;
  useCard?: boolean,
  name: string;
  className?: string;
}

const ServiceLineTypePreServiceCart = ({
  serviceId,
  eventId,
  useCard,
  className,
  ...etc
}: PreServiceLineEventSubscriptionProps & Partial<InputLineProps>) => {
  const service = useSelector(selectEventCategoryPreService(serviceId));
  const { t } = useTranslation();
  const inputsPropByFactory = useMemo(() => servicesInputFactory(service, t, true), [serviceId]);
  const currency = useSelector(selectEventCurrency(eventId));
  const cart = useSelector(selectCurrentCartDetail);

  const inputProps = {
    labelWidthAuto: true,
    textAlignment: 'flex-end' as TextAlignment,
    price: service?.price?.toFixed(2),
    currency: currency ?? cart?.price?.currency,
    url: service.url,
    ...etc,
    ...inputsPropByFactory,
  };

  return (
    <ServiceLineRaw
      className={className}
      useCard={useCard}
      labelText={service.label}
      labelUrl={service.url}
      {...inputProps}
    />
  );
};

export default ServiceLineTypePreServiceCart;
